import { graphql } from "gatsby";
import React from "react";

import BlogPageComponent from "../../components/blog";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import Hero from "../../components/shared/hero";
import { ThemeContext } from "../../context/ThemeContext";
import { formatHeroBackgroundOptions } from "../../utils/formatContent";

const BlogPage = (props) => {
  const { data } = props;
  const { page } = data;
  const { acfLandingPage, globalConfig } = page || {};

  const heroOpts = formatHeroBackgroundOptions(globalConfig);

  const heroBackgroundImage = heroOpts?.image?.desktop;
  const heroBackgroundImageMobile = heroOpts?.image?.mobile;

  const heroOverlayTitle = acfLandingPage?.genHeaderOverlayTitle ?? "GVI Blog";

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page?.title ?? "Blog"}
          containerClass={"w-full mx-auto"}
          brandingOpts={{ ...theme }}
          updateOnScroll={false}
        >
          <Hero
            heroHeadLine={heroOverlayTitle}
            heroImg={heroBackgroundImage}
            navLinks={""}
            heroImageMobile={heroBackgroundImageMobile}
          />
          <BlogPageComponent data={data} />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const query = graphql`
  query {
    page: wpPage(slug: { eq: "blog" }) {
      id
      slug
      title
      locale {
        locale
      }
      seo {
        ...seoFragment
      }
      ...WpPage_SeolegacyFragment
      translations {
        locale
        post_title
        id
        href
      }
      translated {
        ...translatedPageFragment
      }
      template {
        templateName
      }
      globalConfig {
        backgroundImage {
          ...fullwidthFeaturedHeaderImageData
        }
        backgroundImageMobile {
          ...fullwidthFeaturedHeaderImageData
        }
      }
      acfLandingPage {
        genHeaderOverlayTitle
        genSubtitle
      }
    }
    allWpPost(sort: { date: DESC }) {
      nodes {
        title
        slug
        date
        featuredImage {
          node {
            sourceUrl
          }
        }
        author {
          node {
            name
          }
        }
        blogPosts {
          blurb
        }
      }
    }
    genericDetails: wp {
      globalProgramConfig: gviConfigSettings {
        acfGenericGlobalConfig {
          ...StickyWidgetFragment
          ...ExclusiveOffersFragment
        }
      }
    }
  }
`;

export default BlogPage;
